import { createRouter, createWebHashHistory } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useBuyerStore } from '@/stores/BuyerStore'

const routes = [    
    {
      path: "/",
      component: () => import("@components/Buyer.vue"),
      children: [
        {
          path: "",          
          redirect: { name: "TabOpen" }
        },
        {
          path: "car/:uuid",          
          name: "car",
          component: () => import("@components/buyerComponents/CarPageComponent.vue"),
        },
        {
          path: "tab",          
          component: () => import("@components/buyerComponents/Tabs.vue"),
          children: [
            {
              path: "open",
              name: "TabOpen",
              component: () => import("@components/buyerComponents/TabOpen.vue"),
            },
            {
              path: "waiting",
              name: "TabWaiting",
              component: () => import("@components/buyerComponents/TabWaiting.vue"),
            },
            {
              path: "accepted",
              name: "TabAccepted",
              component: () => import("@components/buyerComponents/TabAccepted.vue"),
            },
            {
              path: "history",
              name: "TabHistory",
              component: () => import("@components/buyerComponents/TabHistory.vue"),
            },
          ]
        },
      ],
    },
    
    // Always leave this as last one,
    // but you can also remove it
    {
      path: "/:catchAll(.*)*",
      component: () => import("@components/404.vue"),
    },
  ];

  const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHashHistory(),
    routes, // short for `routes: routes`
  })

  router.beforeEach(async (to, from) => {
    const buyerStore = useBuyerStore()
    await buyerStore.getProfile()
    const { authenticated } = storeToRefs(buyerStore)
    if(!authenticated.value) {
      window.location = '/ostajille'
      return false
    }
  })
  
  export default router;
  